import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42be51e9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "final-price-block" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "final-price-block__icon" }, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "final-price-block__title"
}
const _hoisted_4 = { class: "panel" }
const _hoisted_5 = {
  key: 0,
  class: "panel__title"
}
const _hoisted_6 = { class: "panel__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.withTitle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Финальная цена "))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(['panel-wrapper', { 'panel-wrapper--reverse': _ctx.isReversePanel }])
    }, [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.withPanelTitle)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Финальная цена "))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, " На это блюдо не применяются промо-коды и скидки. " + _toDisplayString(_ctx.companyStore.activeCompany?.hasBonusPoints
              ? 'Не начисляются и не списываются бонусы.'
              : ''), 1)
      ])
    ], 2)
  ]))
}